import { ArrowRightIcon } from 'lucide-react'

import { Button } from '@/components/button/button'

import { useDialog } from '@/lib/hooks/use-dialog'
import { cn } from '@/lib/utils'

import { AddMoreInformationDialog } from '../dialogs/add-more-information-dialog/add-more-information-dialog'

export const CheckCaseInformation = () => {
  const {
    isDialogOpen: isAddMoreInformationDialogOpen,
    openDialog: openAddMoreInformationDialog,
    closeDialog: closeAddMoreInformationDialog,
    setIsDialogOpen: handleAddMoreInformationDialogOpen,
  } = useDialog()

  return (
    <>
      <Button variant="outline" className={cn('w-full', 'h-[56px]', 'p-4')} onClick={openAddMoreInformationDialog}>
        <p className={cn('mr-auto')}>View more</p>
        <ArrowRightIcon size={24} />
      </Button>
      {isAddMoreInformationDialogOpen && (
        <AddMoreInformationDialog
          isDialogOpen={isAddMoreInformationDialogOpen}
          closeDialog={closeAddMoreInformationDialog}
          handleChangeDialogOpen={handleAddMoreInformationDialogOpen}
        />
      )}
    </>
  )
}
